
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * ダウンロードボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonDownload extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
